import { render, staticRenderFns } from "./RelatorioNotasNaoProcessadas.vue?vue&type=template&id=dbbc995c"
import script from "./RelatorioNotasNaoProcessadas.vue?vue&type=script&lang=js"
export * from "./RelatorioNotasNaoProcessadas.vue?vue&type=script&lang=js"
import style0 from "./RelatorioNotasNaoProcessadas.vue?vue&type=style&index=0&id=dbbc995c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports